import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import "./SignIn.less";
import { ROUTE_OTP, ROUTE_SIGNUP } from "../../../constant/routes";
import { Link } from "react-router-dom";
import { useGenerateOtpMutation } from "../../../redux/services/auth";
import { useDispatch } from "react-redux";
import { setId, setMobileNumber } from "../../../redux/features/authSlice";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [generateOtp, { isLoading }] = useGenerateOtpMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGenerateOtp = async (e) => {
    const phoneNumber = parseInt(e.phone, 10);
    dispatch(setMobileNumber(phoneNumber));

    try {
      const response = await generateOtp(phoneNumber).unwrap();
      if (response?.data?.id) {
        message.success("OTP sent successfully");
        dispatch(setId(response.data.id));
        navigate(ROUTE_OTP);
      } else {
        message.error("Failed to generate OTP,Try Again");
      }
    } catch (error) {
      message.error("Error generating OTP:", error);
    }
  };

  return (
    <div className='login-container'>
      <div className='login-box'>
        <h2 className='login-title'>Login in to your account</h2>
        <Form
          name='login'
          initialValues={{ remember: true }}
          layout='vertical'
          onFinish={handleGenerateOtp}
        >
          <Form.Item>
            <Form.Item
              name='phone'
              noStyle
              rules={[
                {
                  required: true,
                  message: "Please enter your phone number!",
                },
                {
                  pattern: /^[6-9]\d{9}$/,
                  message:
                    "Please enter a valid 10-digit phone number starting with 6-9",
                },
              ]}
            >
              <Input
                placeholder='Enter Phone Number'
                prefix='+91'
                className='input-number'
              />
            </Form.Item>
          </Form.Item>

          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              className='continue-button'
              loading={isLoading}
            >
              Continue
            </Button>
          </Form.Item>
        </Form>
        <p>
          <span classname='login-register-line'>Don't have an account?</span>
          <Link to={ROUTE_SIGNUP} onClick={() => dispatch(setMobileNumber(""))}>
            <span className='login-register-link'> Register</span>
          </Link>
        </p>
        <p className='terms'>
          <span>By continuing, you agree to</span>
          <span>
            <Link href='#'>Terms of Service</Link>,
            <Link href='#'>Privacy Policy</Link>,
            <Link href='#'>Content Policy</Link>.
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;
